const data = {
  "adviceAgent": {
    "headerTitle": "Digitale specialist",
    "errorMessage": "Oeps de specialist is even offline. Probeer het later nog eens.",
    "disclaimer": "Onze digitale specialist helpt je, maar kan zich net als een mens soms vergissen.",
    "addToCartButton": {
      "label": "In mijn winkelwagen"
    }
  }
};

export default data;